import { inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { CartStoreService } from './cart-store.service';
import { ItemAFusionar } from '../models/carrito.model';
import { CustomerSessionListener } from '@prosell/feature-customer-auth/customer-auth.tokens';
import { ctxTienda } from '@prosell/feature-customer-auth/utils/storefront-context.util';

/**
 * Une la sesión del cliente con el carrito, que `feature-customer-auth` no conoce. El backend de clientes no adopta
 * el carrito del invitado al autenticar: se captura antes del login (aún es el del invitado) y se fusiona después
 * con `POST /sales/carrito/fusionar`; lo que no pudo pasar vuelve como avisos.
 */
export function cartSessionListener(): CustomerSessionListener {
  const cart = inject(CartStoreService);
  return {
    capturar: (): ItemAFusionar[] => (cart.carrito()?.grupos ?? [])
      .flatMap(g => g.items)
      .map(i => ({ sellerOfferId: i.sellerOfferId, quantity: i.quantity })),
    adoptar: (captura): Observable<string[]> => {
      const items = (captura as ItemAFusionar[] | undefined) ?? [];
      if (items.length === 0) {
        // Sin nada que fusionar, el carrito en memoria era el del invitado: se relee el de la cuenta.
        cart.limpiar();
        return cart.refrescar(ctxTienda()).pipe(map(() => []), catchError(() => of([])));
      }
      return cart.fusionar(items, ctxTienda()).pipe(map(r => r.conflictos.map(c => c.motivo)));
    },
    alCerrarSesion: () => cart.limpiar()
  };
}
